// extracted by mini-css-extract-plugin
export default {"left-margin":"DeleteNews_left-margin__xnbuN"};